export default function matchFeaturesAndSelectedCropzones(
  featureCollection,
  cropZones = []
) {
  if (!cropZones.length) return [];
  const featuresById = new Map(
    featureCollection.features.map(f => [f.properties.id, f])
  );
  return cropZones.map(id => featuresById.get(id)).filter(Boolean);
}
